import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    getProfileInformation
} from '../../redux/admin/adminActions'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import { Formik, Field } from 'formik'
import CustomImageInput from "../../components/Form/CustomImageInput/Index"
import * as yup from "yup"
import TextField from "@material-ui/core/TextField"
import Alert from '@material-ui/lab/Alert'
import Button from "@material-ui/core/Button"
import Modal from '@material-ui/core/Modal'
import Snackbar from "@material-ui/core/Snackbar/Snackbar"
import Backdrop from "@material-ui/core/Backdrop/Backdrop"
import Fade from "@material-ui/core/Fade"
import CloseIcon from '@material-ui/icons/Close'
import axios from "axios"
import { withStyles } from "@material-ui/core/styles"
import CircularProgress from "@material-ui/core/CircularProgress"
import Skeleton from "@material-ui/lab/Skeleton"
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'

const useStyles = makeStyles((theme) => ({
    title: {
        backgroundColor: '#950000',
        borderRadius: '10px',
        color: '#fff',
        fontWeight: '700'
    },
    paperNoBg: {
        backgroundColor: 'transparent',
    },
    container: {
        backgroundColor: '#F3F3F3',
        margin: '-10px auto',
        padding: '20px',
        borderBottomRadius: '10px',
        width: '98%',

    },
    whitecontainer: {
        margin: '0px',
    },
    green: {
        backgroundColor: "#417557",
        boxShadow: "none",
        color: "#fff",
        width: "140px",
        "&:hover": {
            background: "#447557",
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '15px',
            marginRight: '17px'
        },
    },
    btnChangePass: {
        [theme.breakpoints.down('xs')]: {
            marginTop: '15px',
            marginBottom: '15px',
        }
    },
    whiteBox: {
        background: "#fff",
        borderRadius: '20px',
    },
    whiteBox1: {
        background: "#fff",
        borderRadius: '20px',
        paddingBottom: '45px',
        [theme.breakpoints.up('sm')]: {
            minHeight: '506px'
        }
    },
    whiteBox2: {
        background: "#fff",
        borderRadius: '20px',
        [theme.breakpoints.up('sm')]: {
            minHeight: '477px',
        }
    },
    btn: {
        padding: theme.spacing(1.2),
        backgroundColor: "transparent",
        fontWeight: "700",
        maxWidth: "170px",
        borderRadius: "10px 10px 0px 0px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
        color: "#616161",
        border: "1px solid #D0D0D0",
        borderBottom: "none",
        width: "100%",
    },
    btnActive: {
        padding: theme.spacing(1.2),
        borderRadius: "10px 10px 0px 0px",
        maxWidth: "170px",
        backgroundColor: "#F3F3F3",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#F3F3F3",
            boxShadow: "none",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    formControl: {
        margin: theme.spacing(1),
        width: "100%",
        backgroundColor: "#ffffff",
        borderRadius: "10px",
    },
    show: {
        display: "block",
    },
    hide: {
        display: "none",
    },
    label: {
        lineHeight: "32px",
        fontSize: "13px",
        fontWeight: "700",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: '0px',
    },
    modalContainer: {
        padding: theme.spacing(2, 4, 3),
        paddingLeft: "25px",
        paddingBottom: "50px",
        paddingRight: "25px",
    },
    paperModal: {
        width: "470px",
        background: "#F9F9F9",
        boxSizing: "border-box",
        borderRadius: " 10px",
        paddingTop: '0px',
        outline: "none",

        [theme.breakpoints.down(650)]: {
            width: "85%",
        },
        [theme.breakpoints.up(2560)]: {
            width: "999px",
        },

        [theme.breakpoints.down(340)]: {
            borderTopLeftRadius: "15px",
            borderTopRightRadius: "15px",
            paddingLeft: "10px",
            paddingRight: "10px",
        },
    },
    imgC:
    {
        borderRadius: '10px',
        filter: 'drop-shadow(-4px 4px 8px rgba(0, 0, 0, 0.19))',
    }
}));

const StyledPaper = withStyles({
    root: {
        backgroundColor: "transparent",
        position: "relative",
        boxShadow: "none",
        paddingTop: "0",
    },
})(Paper);

const LimitedBackdrop = withStyles({
    root: {
        backgroundColor: "rgb(0, 0, 0,0.2)",
        height: "105%",
        position: "absolute",
        zIndex: 1,
        color: "#fff",
        borderRadius: "10px",
        marginTop: "-10px",
    },
})(Backdrop);

const ManageProfile = () => {

    const dispatch = useDispatch()
    const classes = useStyles()
    const profileInformation = useSelector(state => state.adminProfileInformation)

    const {
        loading,
        address,
        fullName,
        mobileNumber,
        imageURL,
        information,
    } = profileInformation

    const [imageUpdateRequestActive, setImageUpdateRequestActive] = useState(false)
    const [pageLoading, setPageLoading] = useState(true);
    const [openModal, setOpenModal] = React.useState(false);
    const [passwordUpdateRequestActive, setPasswordUpdateRequestActive] = useState(false)

    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: "",
    });

    const [userTokenLocal, setUserTokenLocal] = useState(
        localStorage.getItem("token")
    );

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const toggleCloseAlert = () => {
        setAlert({
            open: false,
            type: '',
            message: '',
        })
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const [imageUploadBtnText, setImageUploadBtnText] = useState("ذخیره")
    const [persian, setPersian] = useState(true);
    const [arabic, setArabic] = useState(false);
    const [show, setShow] = React.useState(true);
    const TogglePersian = () => {
        setArabic(false);
        setPersian(true);
    };

    const ToggleArabic = () => {
        setPersian(false);
        setArabic(true);
    };

    const handleClickShowPassword = () => {
        setShow(!show);
    };

    const handleMouseDownPassword = (event) => {
        setShow(false);
    };

    const updatePassword = async (datas) => {
        setPageLoading(true);
        try {
            const { data } = await axios.post(`/api/admin/accounts/profile/updatepassword`, datas, {
                headers: {
                    Authorization: `Bearer ` + localStorage.getItem("token"),
                    "content-type": "multipart/form-data",
                },
            });
            if (data.status === "error" && data.message === "CurrentPasswordInvalid") {
                toggleOpenAlert("error", "رمز عبور فعلی صحیح نمی باشد.");
                setPageLoading(false);
            }
            else if (data.status === "ok") {
                toggleOpenAlert("success", "تصویر کاربری با موفقیت ثبت شد.");
                setPageLoading(false);
            } else {
                toggleOpenAlert("error", "عملیات با خطا مواجه شده است.");
                setPageLoading(false);
            }
        } catch (error) {
            console.error(error);
            toggleOpenAlert("error", "خطا در ارتباط با سرور");
            setPageLoading(false);
        }
    };

    const updateProfile = async (datas) => {
        setPageLoading(true);
        try {
            const { data } = await axios.post(`/api/admin/accounts/profile/update`, datas, {
                headers: {
                    Authorization: `Bearer ` + localStorage.getItem("token"),
                    "content-type": "multipart/form-data",
                },
            })
            if (data.status === "ok") {
                toggleOpenAlert("success", "اطلاعات با موفقیت بروزرسانی شد.");
                setPageLoading(false);
            } else {
                toggleOpenAlert("error", "عملیات با خطا مواجه شده است.");
                setPageLoading(false);
            }
        } catch (error) {
            console.error(error);
            toggleOpenAlert("error", "خطا در ارتباط با سرور");
            setPageLoading(false);
        }
    };

    const toggleOpenAlert = (Type, msg) => {
        setAlert({
            open: true,
            type: Type,
            message: msg,
        });
    };

    useEffect(() => {
        dispatch(getProfileInformation())
    }, [])

    useEffect(() => {
        if (typeof loading !== "undefined") {
            setPageLoading(loading)
        }
    }, [loading])

    const FILE_SIZE = 160 * 1024 * 160

    const SUPPORTED_FORMATS = [
        "image/jpg",
        "image/jpeg",
        "image/gif",
        "image/png"
    ]

    const validationSchema = yup.object().shape({
        fName: yup
            .string("پر کردن این فیلد الزامی است")
            .required("نام و نام خانوادگی الزامی است"),
        Address: yup
            .string("پر کردن این فیلد الزامی است")
            .required("نام و نام خانوادگی الزامی است"),
        PhoneNumbers: yup
            .string("پر کردن این فیلد الزامی است")
            .required("نام و نام خانوادگی الزامی است"),
        WorkTime: yup
            .string("پر کردن این فیلد الزامی است")
            .required("نام و نام خانوادگی الزامی است"),
        ShortAboutText: yup
            .string("پر کردن این فیلد الزامی است")
            .required("پر کردن این فیلد الزامی است"),

    })

    const validationSchema2 = yup.object().shape({
        CurrentPassword: yup.string()
            .required('ورود رمز عبور فعلی اجباری است'),
        NewPassword: yup
            .string()
            .required("لطفا رمز عبور جدید را وارد کنید"),
        // .matches(
        //     /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        //     "رمز عبور باید شامل اعداد ، حروف ، کلمات ویژه و حداقل 8 رقم باشد"
        // ),
        NewPasswordVer: yup
            .string()
            .required("تکرار رمز عبور الزامی می باشد")
            .oneOf([yup.ref("NewPassword"), null], "رمز عبور با تکرار آن یکسان نمی باشد."),
    })

    return (
        <>
            <Box evelotion={0} mt={1}>
                <StyledPaper>
                    <LimitedBackdrop open={pageLoading}>
                        <CircularProgress color="inherit" />
                    </LimitedBackdrop>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Box evelotion={0} textAlign="center" p={1} className={classes.title}>
                                پروفایل مدیریت
                        </Box>
                        </Grid>
                    </Grid>
                    <Formik
                        enableReinitialize
                        initialValues={{
                            image: '',
                            fName: (!loading) ? fullName : '',
                            Address: (!loading) ? information.address : '',
                            PhoneNumbers: (!loading) ? information.phoneNumbers : '',
                            WorkTime: (!loading) ? information.workTime : '',
                            ShortAboutText: (!loading) ? information.shortAboutText : '',
                            ArAddress: (!loading) ? information.arAddress : '',
                            ArPhoneNumbers: (!loading) ? information.arPhoneNumbers : '',
                            ArWorkTime: (!loading) ? information.arWorkTime : '',
                            ArShortAboutText: (!loading) ? information.arShortAboutText : '',
                        }}
                        validationSchema={validationSchema}
                        onSubmit={async (values, { setStatus, setSubmitting }) => {
                            setStatus()
                            try {
                                let formData = new FormData();
                                Object.keys(values).forEach(function eachKey(key) {
                                    if (key === "fName")
                                        formData.append("FullName", values.fName)
                                    else
                                        formData.append(key, values[key]);
                                });
                                updateProfile(formData)
                            } catch (error) {
                                //console.log(error)
                            }
                        }}
                        render={({ errors, status, touched, handleChange, handleSubmit, setFieldValue, handleBlur, values, isSubmitting }) => (
                            <form onSubmit={handleSubmit} style={{ width: '100%' }}>


                                <Grid container className={classes.container} spacing={1}>
                                    <Grid item md={6} xs={12} >
                                        <Box evelotion={1} mt={-1} p={2} className={classes.whiteBox1}>
                                            <div style={{ borderBottom: '1px #ccc solid', marginBottom: '20px' }}>
                                                <strong style={{ marginBottom: '10px', display: 'block' }}>اطلاعات شخصی</strong>
                                            </div>
                                            <Grid container>
                                                <Grid item md={3}></Grid>
                                                <Grid item md={6} xs={12}>
                                                    {(loading) ? (
                                                        <Skeleton animation="wave" style={{ width: '100%', height: '250px' }} />
                                                    ) : (
                                                        <Field
                                                            name="image"
                                                            component={CustomImageInput}
                                                            type="image"
                                                            defaultImage={(!loading) ? imageURL : null}
                                                            btnText={imageUploadBtnText}
                                                            btnActivitiy={imageUpdateRequestActive}
                                                            boxHeight="150px"
                                                            noBtn={true}
                                                            setFieldValue={setFieldValue}
                                                            errorMessage={errors["image"] ? errors["image"] : undefined}
                                                            touched={touched["image"]}
                                                            style={{ display: "flex" }}
                                                            onBlur={handleBlur}
                                                        />
                                                    )}
                                                </Grid>
                                                <Grid item md={3}></Grid>
                                                <Grid item md={1}></Grid>
                                                <Grid item md={10} xs={12}>
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={12}>
                                                            <lable className={classes.label}>نام و نام خانوادگی</lable>
                                                            <Box evelotion={0}>
                                                                {(loading) ? (
                                                                    <Skeleton animation="wave" style={{ width: '100%', height: '62px' }} />
                                                                ) : (
                                                                    <TextField
                                                                        fullWidth
                                                                        name="fName"
                                                                        variant="outlined"
                                                                        value={values.fName}
                                                                        onChange={handleChange}
                                                                        style={{ marginTop: '10px' }}
                                                                        error={
                                                                            touched.fName && Boolean(errors.fName)
                                                                        }
                                                                        helperText={
                                                                            touched.fName && errors.fName
                                                                        }
                                                                    />
                                                                )}
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} style={{ textAlign: 'right', marginTop: '25px' }}>
                                                            <lable className={classes.label}>شماره موبایل</lable>
                                                            <Box evelotion={0}>
                                                                {(loading) ? (
                                                                    <Skeleton animation="wave" style={{ width: '100%', height: '62px' }} />
                                                                ) : (
                                                                    <TextField
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        value={(!loading) ? mobileNumber : ''}
                                                                        disabled={true}
                                                                        style={{ marginTop: '10px' }}
                                                                    />
                                                                )}
                                                            </Box>
                                                        </Grid>
                                                        {/* <Grid item md={6} style={{ textAlign: 'right' }}>
                                                            <Button
                                                                variant="contained"
                                                                type="button"
                                                                style={{ marginTop: '20px' }}
                                                                onClick={handleOpenModal}
                                                                className={classes.btnChangePass}
                                                                disabled={isSubmitting}>
                                                                تغییر رمز عبور</Button>
                                                        </Grid> */}
                                                    </Grid>
                                                </Grid>
                                                <Grid item md={1}></Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Box evelotion={1} mt={-1} p={2} className={classes.whiteBox2}>
                                            <Grid container spacing={0}>
                                                <Grid item xs={12}>
                                                    <Box>
                                                        <Button
                                                            className={persian ? classes.btnActive : classes.btn}
                                                            onClick={TogglePersian}>محتوای فارسی</Button>
                                                        <Button
                                                            className={arabic ? classes.btnActive : classes.btn}
                                                            onClick={ToggleArabic}>محتوای عربی</Button>
                                                    </Box>
                                                    <Box
                                                        className={persian ? classes.show : classes.hide}
                                                        pt={3}
                                                        pb={3}
                                                        bgcolor="#F3F3F3"
                                                        style={{ borderRadius: '15px 0px 15px 15px' }}>

                                                        <Grid container>
                                                            <Grid
                                                                style={{ borderLeft: "1px solid rgba(0, 0, 0, 0.12)" }}
                                                                item
                                                                xs={12}
                                                            >
                                                                <Box px={3}>
                                                                    <lable className={classes.label}>آدرس فروشگاه</lable>
                                                                    {(loading) ? (
                                                                        <Skeleton animation="wave" style={{ width: '100%', height: '62px' }} />
                                                                    ) : (
                                                                        <TextField
                                                                            fullWidth
                                                                            name="Address"
                                                                            variant="outlined"
                                                                            value={values.Address}
                                                                            onChange={handleChange}
                                                                            error={touched.Address && Boolean(errors.Address)}
                                                                            helperText={touched.Address && errors.Address}
                                                                        />
                                                                    )}
                                                                </Box>
                                                                <Box px={3} mt={2}>
                                                                    <div className={classes.label}>
                                                                        شماره تلفن
                                                                    </div>
                                                                    {(loading) ? (
                                                                        <Skeleton animation="wave" style={{ width: '100%', height: '62px' }} />
                                                                    ) : (
                                                                        <TextField
                                                                            fullWidth
                                                                            variant="outlined"
                                                                            name="PhoneNumbers"
                                                                            value={values.PhoneNumbers}
                                                                            onChange={handleChange}
                                                                            error={touched.PhoneNumbers && Boolean(errors.PhoneNumbers)}
                                                                            helperText={touched.PhoneNumbers && errors.PhoneNumbers}
                                                                        />
                                                                    )}
                                                                </Box>
                                                                <Box px={3} mt={2} mb={2}>
                                                                    <div className={classes.label}>
                                                                        ساعات کاری
                                                                    </div>
                                                                    {(loading) ? (
                                                                        <Skeleton animation="wave" style={{ width: '100%', height: '62px' }} />
                                                                    ) : (
                                                                        <TextField
                                                                            fullWidth
                                                                            variant="outlined"
                                                                            name="WorkTime"
                                                                            value={values.WorkTime}
                                                                            onChange={handleChange}
                                                                            error={touched.WorkTime && Boolean(errors.WorkTime)}
                                                                            helperText={touched.WorkTime && errors.WorkTime}
                                                                        />
                                                                    )}
                                                                </Box>
                                                                <Box px={3} mt={2} mb={2}>
                                                                    <div className={classes.label}>
                                                                        متن درباره ما فوتر
                                                                    </div>
                                                                    {(loading) ? (
                                                                        <Skeleton animation="wave" style={{ width: '100%', height: '139px' }} />
                                                                    ) : (
                                                                        <TextField
                                                                            fullWidth
                                                                            multiline
                                                                            variant="outlined"
                                                                            rows={5}
                                                                            name="ShortAboutText"
                                                                            value={values.ShortAboutText}
                                                                            onChange={handleChange}
                                                                            error={touched.ShortAboutText && Boolean(errors.ShortAboutText)}
                                                                            helperText={touched.ShortAboutText && errors.ShortAboutText}
                                                                        />
                                                                    )}
                                                                </Box>

                                                            </Grid>
                                                        </Grid>

                                                    </Box>
                                                    <Box
                                                        pt={3}
                                                        pb={3}
                                                        className={arabic ? classes.show : classes.hide}
                                                        bgcolor="#F3F3F3"
                                                        style={{ borderRadius: '15px 0px 15px 15px' }}>


                                                        <Grid container mb={2}>
                                                            <Grid
                                                                style={{ borderLeft: "1px solid rgba(0, 0, 0, 0.12)" }}
                                                                item
                                                                xs={12}
                                                            >
                                                                <Box px={3}>
                                                                    <lable className={classes.label}>آدرس فروشگاه</lable>
                                                                    {(loading) ? (
                                                                        <Skeleton animation="wave" style={{ width: '100%', height: '62px' }} />
                                                                    ) : (
                                                                        <TextField
                                                                            fullWidth
                                                                            name="ArAddress"
                                                                            variant="outlined"
                                                                            value={values.ArAddress}
                                                                            onChange={handleChange}
                                                                            error={touched.ArAddress && Boolean(errors.ArAddress)}
                                                                            helperText={touched.ArAddress && errors.ArAddress}
                                                                        />
                                                                    )}
                                                                </Box>
                                                                <Box px={3} mt={2}>
                                                                    <div className={classes.label}>
                                                                        شماره تلفن
                                                                    </div>
                                                                    {(loading) ? (
                                                                        <Skeleton animation="wave" style={{ width: '100%', height: '62px' }} />
                                                                    ) : (
                                                                        <TextField
                                                                            fullWidth
                                                                            variant="outlined"
                                                                            name="ArPhoneNumbers"
                                                                            value={values.ArPhoneNumbers}
                                                                            onChange={handleChange}
                                                                            error={touched.ArPhoneNumbers && Boolean(errors.ArPhoneNumbers)}
                                                                            helperText={touched.ArPhoneNumbers && errors.ArPhoneNumbers}
                                                                        />
                                                                    )}
                                                                </Box>
                                                                <Box px={3} mt={2} mb={2}>
                                                                    <div className={classes.label}>
                                                                        ساعات کاری
                                                                    </div>
                                                                    {(loading) ? (
                                                                        <Skeleton animation="wave" style={{ width: '100%', height: '62px' }} />
                                                                    ) : (
                                                                        <TextField
                                                                            fullWidth
                                                                            variant="outlined"
                                                                            name="ArWorkTime"
                                                                            value={values.ArWorkTime}
                                                                            onChange={handleChange}
                                                                            error={touched.ArWorkTime && Boolean(errors.ArWorkTime)}
                                                                            helperText={touched.ArWorkTime && errors.ArWorkTime}
                                                                        />
                                                                    )}
                                                                </Box>

                                                                <Box px={3} mt={2} mb={2}>
                                                                    <div className={classes.label}>
                                                                        متن درباره ما فوتر
                                                                    </div>
                                                                    {(loading) ? (
                                                                        <Skeleton animation="wave" style={{ width: '100%', height: '139px' }} />
                                                                    ) : (
                                                                        <TextField
                                                                            fullWidth
                                                                            multiline
                                                                            variant="outlined"
                                                                            rows={5}
                                                                            name="ArShortAboutText"
                                                                            value={values.ArShortAboutText}
                                                                            onChange={handleChange}
                                                                            error={touched.ArShortAboutText && Boolean(errors.ArShortAboutText)}
                                                                            helperText={touched.ArShortAboutText && errors.ArShortAboutText}
                                                                        />
                                                                    )}
                                                                </Box>

                                                            </Grid>
                                                        </Grid>


                                                    </Box>


                                                </Grid>

                                            </Grid>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} style={{ textAlign: 'left', marginTop: '10px' }}>
                                        <Box evelotion={0} mt={2} mb={2} style={{ marginBottom: '6px' }}>
                                            <Button
                                                variant="contained"
                                                type="button"
                                                style={{ marginTop: '20px' }}
                                                onClick={handleOpenModal}
                                                className={classes.btnChangePass}
                                                style={{ marginLeft: '20px' }}>
                                                تغییر رمز عبور</Button>
                                            <Button
                                                variant="contained"
                                                type="submit"
                                                className={classes.green}>
                                                ذخیره تغییرات</Button>
                                        </Box>
                                    </Grid>
                                </Grid>

                            </form>
                        )}
                    />

                </StyledPaper>
            </Box>
            <Snackbar
                open={alert.open}
                autoHideDuration={4000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={toggleCloseAlert}>
                <Alert onClose={toggleCloseAlert} severity={alert.type}>
                    {alert.message}
                </Alert>
            </Snackbar>
            <Modal
                open={openModal}
                center
                className={classes.modal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}>
                <Fade in={openModal}>
                    <div className={classes.paperModal}>
                        <div className={classes.modalContainer}>
                            <Box evelotion={0} mt={0} style={{ textAlign: 'center' }}>
                                <h3 style={{ marginTop: '0px' }}>تغییر رمز عبور
                                <CloseIcon onClick={handleCloseModal} style={{ float: 'right', cursor: 'pointer' }} />
                                </h3>
                            </Box>
                            <hr />
                            <Formik
                                initialValues={{
                                    CurrentPassword: '',
                                    NewPassword: "",
                                    NewPasswordVer: "",
                                }}
                                validationSchema={validationSchema2}
                                onSubmit={async (values, { setStatus, setSubmitting }) => {
                                    setStatus();
                                    try {
                                        let formData = new FormData();
                                        Object.keys(values).forEach(function eachKey(key) {
                                            formData.append(key, values[key]);
                                        });
                                        updatePassword(formData)
                                    } catch (error) {
                                        //console.log(error)
                                    }
                                }}
                                render={({ errors, status, touched, handleChange, handleSubmit, handleBlur, setFieldValue, values, isSubmitting }) => (
                                    <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <Box px={3} mt={1}>
                                                    <lable className={classes.label} style={{ fontWeight: '700' }}>رمز عبور فعلی</lable>
                                                    <TextField
                                                        fullWidth
                                                        name="CurrentPassword"
                                                        type="password"
                                                        variant="outlined"
                                                        value={values.CurrentPassword}
                                                        style={{ marginTop: '10px' }}
                                                        onChange={handleChange}
                                                        error={
                                                            touched.CurrentPassword &&
                                                            Boolean(errors.CurrentPassword)
                                                        }
                                                        helperText={
                                                            touched.CurrentPassword && errors.CurrentPassword
                                                        }
                                                    />
                                                </Box>
                                                <Box px={3} mt={2}>
                                                    <lable className={classes.label} style={{ fontWeight: '700' }}>رمز عبور جدید</lable>
                                                    <TextField
                                                        dir="ltr"
                                                        type={show ? 'password' : 'text'}
                                                        fullWidth
                                                        name="NewPassword"
                                                        variant="outlined"
                                                        value={values.NewPassword}
                                                        style={{ marginTop: '10px' }}
                                                        onChange={handleChange}
                                                        error={touched.NewPassword && Boolean(errors.NewPassword)}
                                                        helperText={touched.NewPassword && errors.NewPassword}
                                                        InputProps={{
                                                            endAdornment: (<InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowPassword}
                                                                    edge="end"
                                                                >
                                                                    {show ? <Visibility /> : <VisibilityOff />}
                                                                </IconButton>
                                                            </InputAdornment>)
                                                        }} />
                                                </Box>
                                                <Box px={3} mt={2}>
                                                    <lable className={classes.label} style={{ fontWeight: '700' }}>تایید رمز عبور</lable>
                                                    <TextField
                                                        dir="ltr"
                                                        type={show ? 'password' : 'text'}
                                                        fullWidth
                                                        name="NewPasswordVer"
                                                        variant="outlined"
                                                        value={values.NewPasswordVer}
                                                        style={{ marginTop: '10px' }}
                                                        onChange={handleChange}
                                                        error={touched.NewPasswordVer && Boolean(errors.NewPasswordVer)}
                                                        helperText={touched.NewPasswordVer && errors.NewPasswordVer}
                                                        InputProps={{
                                                            endAdornment: (<InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowPassword}
                                                                    edge="end"
                                                                >
                                                                    {show ? <Visibility /> : <VisibilityOff />}
                                                                </IconButton>
                                                            </InputAdornment>)
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Box evelotion={0} style={{ textAlign: 'left', marginTop: '20px' }}>
                                                    <Button
                                                        variant="contained"
                                                        type="submit"
                                                        style={{ marginLeft: '23px' }}
                                                        disabled={passwordUpdateRequestActive}
                                                        className={classes.green}>
                                                        تایید
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </form>
                                )}
                            />
                        </div>
                    </div>
                </Fade>
            </Modal>
        </>
    )
}

export default ManageProfile
